import { render, staticRenderFns } from "../../../pages/salesRep/notic/notic.html?vue&type=template&id=0584805c&scoped=true&"
import script from "../../../pages/salesRep/notic/notic.js?vue&type=script&lang=js&"
export * from "../../../pages/salesRep/notic/notic.js?vue&type=script&lang=js&"
import style0 from "../../../pages/salesRep/notic/notic.css?vue&type=style&index=0&id=0584805c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584805c",
  null
  
)

export default component.exports